export const version = {
  hash: 'aff6d000',
};
